import styled from 'styled-components';
import {
  desktop_breakpoint,
  tablet_container_maxwidth,
  mobile_width_percentage,
  desktop_container_maxwidth_compact,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const HomeStreamStyles = styled.div`
  border-bottom: 1px solid ${Colors.secondary.grey6.standard};
  width: 100%;

  a.header-link:link,
  a.header-link:visited,
  a.header-link:hover,
  a.header-link:active {
    display: inline-block;
    text-decoration: none;

    h4 {
      display: inline-block;
    }
  }

  .container {
    padding: 50px 0;
    margin: auto;
    max-width: ${tablet_container_maxwidth}px;
    width: ${mobile_width_percentage}%;
  }

  &.hide-prev {
    .carousel.carousel-slider .control-prev {
      display: none;
    }
  }

  &.hide-next {
    .carousel.carousel-slider .control-next {
      display: none;
    }
  }

  h4 {
    margin-bottom: 20px;
  }
  .slider-wrapper .slider .slide {
    background-color: ${Colors.primary.white.standard};
    text-align: left;

    &.selected ~ .selected {
      display: none;
    }

    &.selected + .selected {
      display: flex;
    }
  }

  .control-dots {
    display: none;
  }

  .carousel.carousel-slider .control-prev,
  .carousel.carousel-slider .control-prev:hover,
  .carousel.carousel-slider .control-next,
  .carousel.carousel-slider .control-next:hover {
    top: calc(50% - 25px);
    transform: translateY(-50%);
  }

  .carousel.carousel-slider .control-prev {
    left: -22.5px;
  }

  .carousel.carousel-slider .control-next {
    right: -22.5px;
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    .container {
      margin: auto;
      max-width: ${desktop_container_maxwidth_compact + 38}px;
      width: calc(${mobile_width_percentage}% + 30px);
    }

    h4 {
      padding-left: 20px;
    }
    .carousel .slider {
      margin-left: -25%;
    }

    .slide {
      & > div {
        margin: auto;
        width: calc(90% + 10px);
      }
    }

    .carousel.carousel-slider .control-prev {
      left: -15px;
    }

    .carousel.carousel-slider .control-next {
      right: -15px;
    }
  }

  @media screen and (min-width: 960px) {
    .container {
      margin: auto;
      max-width: ${desktop_container_maxwidth_compact + 38}px;
    }

    .carousel .slider {
      margin-left: -33.33%;
    }

    .slide {
      & > div {
        margin: auto;
        width: 90%;
      }
    }

    .carousel.carousel-slider .control-prev {
      left: -50px;
    }

    .carousel.carousel-slider .control-next {
      right: -50px;
    }
  }
`;
